import { useCookies } from "react-cookie";

const PATH = "/";

const useTempStorage = (key) => {
  const [cookies, setCookie, removeCookie] = useCookies(["name"]);
  const cookie = cookies[key];
  const updateCookie = (value) => setCookie(key, value, { path: PATH });
  const deleteCookie = () => removeCookie(key, { path: PATH });
  return { cookie, updateCookie, deleteCookie };
};

export const KEY_COOKIE_HASH_PEDIDO = "tokenPedidoPT";
export const KEY_COOKIE_CPF_PEDIDO = "cpfPedidoPT";

export default useTempStorage;
